import { Button, Table,Spin, Modal, Form, Input, Select} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import {AUTH_URL} from '../constants';
import {IMetaDataGlobal} from '../factory/interfaces'
import { IoEnterSharp } from "react-icons/io5"
import { notify, notify_success, toastStyle } from '../pages/LoginPage';
import { selectUserDetails } from '../features/auth/authSlice';
import { useSelector } from 'react-redux';


const SecurityTypesTable = () => {
    const dispatch = useDispatch()
    const [showExpenseForm, setShowExpenseForm] = useState(false)
    const [addingExpense, setAddingExpense] = useState(false)
    const [reloadComponent, setReloadComponent] = useState(false)
    const [securityTypes, setSecurityTypes] = useState<IMetaDataGlobal[]>()

    const [form] = Form.useForm()

     //Redux states
    const userDetails = useSelector(selectUserDetails)
    const isAdmin = userDetails?.role === 'admin'
    const metadata = useSelector((state: any) => state.metadata)

    //Functions

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Security type',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Date of creation',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },

];

  const handleClose = ()=>{
    setShowExpenseForm(false)
    form.resetFields()
    }
  const showForm = ()=>setShowExpenseForm(true)


    const getSecurityTypes = async()=>{
      const response = await axios.get(`${AUTH_URL}/meta/security-types`, {withCredentials: true})
      if(response.data.success){
        setSecurityTypes(response.data.security_types)
      }

    }

    const registerSecurityType = async()=>{
      setAddingExpense(true)
      const expenseData = {
        name: form.getFieldValue('name')
      }
      const response = await axios.post(`${AUTH_URL}/meta/security-types`, expenseData, {withCredentials: true})
      setAddingExpense(false)
      if(response.data.success){
        notify_success(`${response.data.message}`, toastStyle)
        form.resetFields()
        handleClose()
        setReloadComponent(true)
      }else{
        notify(`${response.data.message}`, toastStyle)

      }
    }


  useEffect(()=>{
    if(reloadComponent){
        getSecurityTypes()
        setReloadComponent(false)
    }
}, [reloadComponent])

  useEffect(()=>{
    getSecurityTypes()

  }, [dispatch])


  return (
    <>
    {securityTypes? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         </Col>
         <Col className='text-end py-2'>
            <Button type='primary' onClick={showForm} className='rounded-0 mx-1 small text-uppercase'> <IoEnterSharp style={{marginRight: '5px'}} /> <span>Register Accepted Security type</span></Button>
         </Col>
        </Row>
    
     {
      securityTypes &&
      <Table pagination={false} className='rounded-0 transactions-table' id='dlms-expenses-data' bordered dataSource={securityTypes} columns={columns} 
       />
     }
     
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading security types..." size="large">
        <div className="content" />
      </Spin>

    }
   
      <Modal
      width={600} open={showExpenseForm} onCancel={handleClose}
         title={`REGISTER NEW LOAN SECURITY TYPE`}
         centered
         footer={[
                     [

                      ]
                ]}
      >
      <Form
          layout="vertical"
          form={form}
          onFinish={registerSecurityType}

          >
          <Form.Item 
          label="Loan Security Type Name"
          name="name"
          rules={[{ required: true, message: "Security type name is required" }]}
          tooltip='Enter loan security type. E.g. LAND TITLE'
          >
              <Input placeholder='Enter security name' style={{width: '100%'}} className='rounded-0'
                />
          </Form.Item>
          <Row className='d-flex gap-4' style={{marginTop: '40px'}}>
          <Col className='d-flex'>
          <Button loading={addingExpense} htmlType="submit" type='primary' className='rounded-0 text-uppercase small' key="edit_user">
              <span><SaveOutlined style={{marginRight: '5px'}} /></span>
              
              {
              addingExpense ?
              'Registering Security type...'
              :
              'Register Security type'
              
              }
          </Button>
          <Button  className='rounded-0 small text-uppercase mx-3' key="cancel" onClick={handleClose}>
            <CloseOutlined />   Cancel
          </Button>
          
          </Col>
          </Row>
          
        </Form>
      </Modal>
    </>
  )
}

export default SecurityTypesTable